import SearchBox2 from './SearchBox'

export default SearchBox2
